import { DataGrid, GridColDef, GridRowModel } from "@mui/x-data-grid";
import {  AdminTeamsResponse, NhlTeam } from "models/AdminModels";
import { Box, Button } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { NhlPlayoffsResponse } from "models/NhlModels";
// import "./AdminTeams.scss";

export const AdminTeams = () => {
  const [teams, setTeams] = useState<NhlTeam[]>([]);

  useEffect(() => {
    //TODO:DF Local loading indicator
    axios.get<AdminTeamsResponse>(`${process.env.REACT_APP_API_URL}/admin/nhlTeams`).then((r) => {
      setTeams(r.data.nhlTeams);
    });
  }, []);

  const columns: GridColDef[] = [
    {
      field: "name",
      headerName: "Name",
      width: 150,
      type: "string",
      editable: true,
    },
    {
      field: "seed",
      headerName: "Seed",
      width: 150,
      type: "number",
      editable: true,
    },
    {
      field: "divisionId",
      headerName: "Division",
      type: "number",
      width: 100,
      editable: true,
    },
    {
      field: "nhlShortName",
      headerName: "Short Name",
      type: "string",
      width: 150,
      editable: true,
    },
    {
      field: "isActive",
      headerName: "Is Active",
      type: "boolean",
      width: 150,
      editable: true,
    },
  ];

  const update = async () => {
    //TODO:DF local loading indicator
    const result = await axios.put<AdminTeamsResponse>(`${process.env.REACT_APP_API_URL}/admin/nhlTeams`, { nhlTeams: teams });
    setTeams(result.data.nhlTeams);
  };

  const resetSeason = async () => {
    //TODO:DF local loading indicator
    const response = await axios.delete<AdminTeamsResponse>(`${process.env.REACT_APP_API_URL}/admin/season`);
    if (response.status !== 200) {
      //TODO:DF error case
    }
    setTeams(response.data.nhlTeams)
  };
  
  const setupNewSeason = async () => {
    const response = await axios.get<NhlPlayoffsResponse>(`${process.env.REACT_APP_API_URL}/nhl/playoffs`);
    var round1 = response.data.series.filter((c) => c.playoffRound === 1);
    round1.sort((a,b) => a.seriesLetter > b.seriesLetter ? 1 : -1);
    if (round1) {
      teams.forEach((team) => {
        team.isActive = false;
        team.seed = -1;
      });
      round1.forEach((series, x) => {
        console.log(`Processing ${series.topSeedTeam.abbrev} vs ${series.bottomSeedTeam.abbrev}`);
        const home = teams.find((c) => c.nhlShortName === series.topSeedTeam.abbrev.toLowerCase())!;
        home.seed = (x % 4) + 1;
        home.isActive = true;
        const away = teams.find((c) => c.nhlShortName === series.bottomSeedTeam.abbrev.toLowerCase())!;
        away.seed = 8 - (x % 4);
        console.log(`    ${away?.name} at ${home?.name}`);
        away.isActive = true;
      });
      setTeams(teams.slice());
    }
  };
 
  const processRowUpdate = useCallback(
    async (newRow: GridRowModel) => {
      // Make the HTTP request to save in the backend
      const match = teams.find(c=> c.teamId === newRow.teamId);
      if(match) {
        columns.forEach((c) => {
          if(c.editable) {
            (match as any)[c.field] = newRow[c.field];
          }
        })
      }     
      return match;
    },
    [teams, columns],
  );

  return (
    <div className="admin-teams">
      <div className="command-list">
        <Button variant="outlined" size="small" onClick={update}>
          Save
        </Button>
        <Button variant="outlined" size="small" onClick={setupNewSeason}>
          Setup New Season
        </Button>
        <Button variant="outlined" size="small" color="error" onClick={resetSeason}>
          Remove Last Years Series & Picks
        </Button>
      </div>
      <Box>
        <DataGrid
          getRowId={(c) => c.teamId}
          autoHeight
          rowHeight={30}
          hideFooter={true}
          rows={teams}
          columns={columns}
          disableRowSelectionOnClick
          processRowUpdate={processRowUpdate}
        />
      </Box>
    </div>
  );
};
